<div class="horizontal-box-list__item">
  <div class="horizontal-box-list__title w-100">
    <ng-content select=".title-content"></ng-content>
  </div>
  <div class="horizontal-box-list__content w-100 d-flex justify-content-center">
    <ng-content select=".content"></ng-content>
  </div>
</div>
